module.exports = __webpack_public_path__ + "img/paralax.2fb90de5.jpg";